import React, { useState } from 'react';
import styled from 'styled-components';
import DiffSearch from '../components/diff/diffSearch';
import { findDifferences } from '../utils/findDifferences';

const Divider = styled.div`
    width: 2px;
    background: ${({ theme }) => theme.border};
    border-radius: 1px;
    flex-shrink: 0;
`;

export default function DiffPage() {
    const [user1, setUser1] = useState();
    const [user2, setUser2] = useState();

    const differences = user1 && user2 ? findDifferences(user1.data[0], user2.data[0]) : {};
    
    return (
        <>
            <div style={{'display': 'flex', 'justifyContent': 'center', 'marginBottom': '1.5rem'}}>
                <span style={{'textDecoration': 'underline', 'fontWeight': 'bold'}}>RSO/RSSI : vous pouvez comparer uniquement les membres de vos étoiles</span>
            </div>
            <div style={{'display': 'flex', 'justifyContent': 'space-around'}}>
                <DiffSearch user={user1} setUser={setUser1} differences={differences}/>
                <Divider />
                <DiffSearch user={user2} setUser={setUser2} differences={differences}/>
            </div>
        </>
    )
}